<template>
    <span>{{ formattedDate }}</span>
</template>
<script setup>import moment from "moment";
import { computed } from "vue-demi";

const props = defineProps({ date: String })
const formattedDate = computed(() => moment(props.date).format('HH:mm MM/DD/YYYY'))
</script>
<style lang="scss"></style>